import {
  VENDA_MAIS_LOAD_CART,
  VENDA_MAIS_SAVE_CART,
  VENDA_MAIS_LOAD_PRICE,
  VENDA_MAIS_COORDENADAS,
  VENDA_MAIS_FORMAS_ENTREGA,
  VENDA_MAIS_ENVIAR,
  VENDA_MAIS_VALIDAR_CUPOM,
  VENDA_MAIS_LOAD_PRODUTO,
  VENDA_MAIS_LOAD_CLIENTE,
  VENDA_MAIS_PRODUTOS_COPIA
} from "../actions/vendaMais";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const state = {
  produtosCopia: []
};

const getters = {
  getProdutosCopia: state => state.produtosCopia
};

const actions = {
  [VENDA_MAIS_LOAD_CART]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v2.carrinho
        .getCarrinhoVendaPlus(
          getters.getFornecedorId,
          payload.token,
          payload.idcliente,
          payload.idformapagamento,
          payload.idtipoassinatura,
          payload.tipoEntrega,
          payload.vendaMais
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [VENDA_MAIS_SAVE_CART]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v2.carrinho
        .salvarCarrinho(
          getters.getFornecedorId,
          payload.token,
          payload.idcliente,
          payload.produtosSelecionados,
          payload.idformapagamento
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [VENDA_MAIS_LOAD_PRICE]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.produto
        .consultaPreco(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [VENDA_MAIS_COORDENADAS]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.coordenadas
        .getLatLng(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [VENDA_MAIS_FORMAS_ENTREGA]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.formaEntrega
        .getListaFormasEntregaCarrinho(
          getters.getFornecedorId,
          payload.token,
          payload.idendereco,
          payload.tipoEntrega,
          payload.idformapagamento,
          payload.cep,
          payload.lng,
          payload.lat
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [VENDA_MAIS_ENVIAR]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedido
        .enviar(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [VENDA_MAIS_VALIDAR_CUPOM]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v2.cupomDesconto.fornecedor
        .validar(
          getters.getFornecedorId,
          payload.codigoCupom,
          payload.idcliente
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [VENDA_MAIS_LOAD_PRODUTO]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v1.vendamais
        .getProdutosVendaPlus(
          getters.getFornecedorId,
          payload.idcliente,
          payload.idcategoria,
          payload.search,
          payload.idformapagamento,
          payload.tipoEntrega
        )
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [VENDA_MAIS_LOAD_CLIENTE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.vendamais
        .cliente(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
          dispatch(ERRORS_SHOW, err);
        });
    });
  },
  [VENDA_MAIS_PRODUTOS_COPIA]: ({ commit }, payload) => {
    commit(VENDA_MAIS_PRODUTOS_COPIA, payload);
  }
};

const mutations = {
  [VENDA_MAIS_PRODUTOS_COPIA]: (state, payload) => {
    const index = state.produtosCopia.findIndex(
      produto => produto.id === payload.id
    );

    if (index !== -1) {
      state.produtosCopia[index] = payload;
    } else {
      state.produtosCopia.push(payload);
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
